import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export interface IDeliveryStats {
  tabs: {
    pending: number
    routes: number
    handover: number
    active: number
    returns: number
    failed: number
    delivered: number
    inbound: number
    cod: number
  }
  pendingByChannel: {
    all: number
    local: number
    supply: number
    pickup: number
  }
}

export const stats = async (params: { warehouseId?: string | null } = {}): Promise<IDeliveryStats> => {
  const query: Record<string, string> = {}
  if (params.warehouseId) query.warehouseId = params.warehouseId
  return httpRequest.get("/ord/delivery_management/stats", query)
}
